import { useMemo } from 'react';
import { OctoOrder } from '@repo/types';

/**
 * Check if an OCTO order has any booked units with available extras.
 * Only considers extras for units that have actually been booked (via unitItems),
 * not all available units in the option.
 */
export default function useHasOctoExtras(octoOrder?: OctoOrder): boolean {
    return useMemo(() => {
        if (!octoOrder?.bookings) return false;

        return octoOrder.bookings.some((booking) => {
            const bookedUnitIds = booking.unitItems?.map((item) => item.unitId) ?? [];
            return booking.option?.units?.some(
                (unit) =>
                    bookedUnitIds.includes(unit.id) && unit.extras && unit.extras.length > 0,
            );
        });
    }, [octoOrder]);
}
